import { FC } from 'react'
import { FlatList, ListRenderItem, StyleProp, StyleSheet, ViewStyle } from 'react-native'
import ColumnDataState from './ColumnDataState'
import ColumnTitle from './ColumnTitle'

interface ColumnProps {
    data?: any[]
    renderItem?: ListRenderItem<any>
    keyExtractor?: (item: any, index: number) => string
    dataState?: string
    title: string
    width?: number
    style?: StyleProp<ViewStyle>
}

const Column: FC<ColumnProps> = ({
    data,
    renderItem,
    keyExtractor,
    dataState,
    title,
    width,
    style,
}) => {
    const backgroundColor = style ? StyleSheet.flatten(style).backgroundColor : undefined

    return (
        <FlatList
            data={data}
            renderItem={renderItem}
            keyExtractor={keyExtractor}
            style={[styles.container, { width }]}
            contentContainerStyle={[styles.contentContainer, { width }]}
            ListEmptyComponent={<ColumnDataState title={dataState ?? ''} />}
            ListHeaderComponent={<ColumnTitle style={{ backgroundColor }}>{title}</ColumnTitle>}
            stickyHeaderIndices={[0]}
            showsVerticalScrollIndicator={false}
        />
    )
}

const styles = StyleSheet.create({
    container: {
        paddingHorizontal: 12,
    },
    contentContainer: {
        alignSelf: 'center',
        paddingHorizontal: 12,
    },
})

export default Column
